"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMReady = void 0;
/**
 * Make sure the DOM is ready before running the "start" function. Either by using the DOMContentLoaded event or by checking the document.readyState.
 * @param start - The function to run when the DOM is ready.
 */
var DOMReady = function (start) {
    if (/comp|inter|loaded/.test(document.readyState)) {
        // In case DOMContentLoaded was already fired, the document readyState will be one of "complete" or "interactive" or (nonstandard) "loaded".
        // The regexp above looks for all three states. A more readable regexp would be /complete|interactive|loaded/
        setTimeout(start, 0);
    }
    else {
        // In case DOMContentLoaded was not yet fired, use it to run the "start" function when document is read for it.
        document.addEventListener('DOMContentLoaded', start, false);
    }
};
exports.DOMReady = DOMReady;
//# sourceMappingURL=dom-ready.js.map